'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const LoadUrlMatcherTypes=require('../../../../dist-es6/client/services/paramSyncService').LoadUrlMatcherTypes;let

ForecastConfig=class ForecastConfig{
static get $inject(){return['$stateProvider','$urlMatcherFactoryProvider']}

constructor($stateProvider,$urlMatcherFactoryProvider){
LoadUrlMatcherTypes($urlMatcherFactoryProvider);
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('forecast',{
url:'/forecast?groupId&personId',
reloadOnSearch:!1});

$stateProvider.state(feature.fullName,feature.config);
}};


module.exports=ForecastConfig;
//# sourceMappingURL=forecastConfig.js.map
